module.exports = __webpack_public_path__ + "img/img22.d28197dc.png";